import type { ContenidoUbicacion, ArticuloUbi } from "./ModalEditarUbicacion";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { TypedTable } from "../../../../components/TypedTable";
import { formatIDArt } from "../../../../ts/util";

export function TablaArticulo(props: { readonly data: ContenidoUbicacion; }) {
	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<ArticuloUbi>();
		const articuloFaseAccesor = (info: ArticuloUbi) => formatIDArt(info.id, info.idFase);

		return [
			columnHelper.accessor(articuloFaseAccesor, { header: "Artículo", meta: { className: "dt-center" } }),
			columnHelper.accessor("descripcion", { header: "Descripción", meta: { className: "dt-center" } }),
			columnHelper.accessor("contenedor", { header: "Contenedor", meta: { className: "dt-center" }, }),
			columnHelper.accessor("cantidad", { header: "Cantidad", meta: { className: "dt-center" }, }),
		];
	}, []);


	const data = useMemo(() => {
		const articulos: ArticuloUbi[] = [...props.data.articulos];
		for (const contenedor of props.data.contenedores) {
			articulos.push(...contenedor.articulos);
		}

		return articulos;
	}, [props.data]);

	return <TypedTable
		className="dataTable display"
		data={data}
		columns={columns}
	/>;
}